import React from "react";
import { Paper, Button, Text, Group, Space } from "@mantine/core";
import { SignatureStack, SignatureTable } from "../components/SignatureTable";
import { GuestBookModal } from "../components/GuestBookModal";
import { useViewportSize } from "@mantine/hooks";

export const GuestBook = () => {
  const [modalOpened, setModalOpened] = React.useState(false);
  const [refreshTable, setRefreshTable] = React.useState(false);
  const { width } = useViewportSize();

  const handleSignClick = () => {
    if (!modalOpened) setModalOpened(true);
  };

  const handleModalClose = () => {
    setModalOpened(false);
    setRefreshTable(!refreshTable); // Toggle to trigger refresh
  };

  return (
    <>
      <GuestBookModal opened={modalOpened} onClose={handleModalClose} />
      <Paper withBorder shadow="xs" p={"xl"}>
        <Text size="lg" fw={500} ta={"center"}>
          Leave us a message!
        </Text>
      </Paper>
      <Space h={"lg"} />
      <Paper withBorder shadow="xs" p={"xl"}>
        {width < 520 ? <SignatureStack refreshTrigger={refreshTable}/> : <SignatureTable refreshTrigger={refreshTable}/>}
        <Space h={"lg"} />
        <Group justify="center">
          <Button bg={"#7fac9d"} onClick={handleSignClick}>
            Sign
          </Button>
        </Group>
      </Paper>
    </>
  );
};